import { render } from "./AllCoupons.vue?vue&type=template&id=79679248&scoped=true"
import script from "./AllCoupons.vue?vue&type=script&lang=js"
export * from "./AllCoupons.vue?vue&type=script&lang=js"

import "./AllCoupons.vue?vue&type=style&index=0&id=79679248&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79679248"]])

export default __exports__